import {create} from 'zustand'; // 상태 관리 라이브러리
import {createJSONStorage, persist} from 'zustand/middleware'; // 상태 지속성을 위한 미들웨어

// 사용자 정보 타입 정의
interface UserInfo {
    userName: string;                   // 사용자 이름
    role: 'ADMIN' | 'CLIENT' | '';      // 사용자 역할 (관리자/클라이언트/미설정)
}

// 사용자 정보 스토어 타입 정의
interface UserInfoStore {
    userInfo: UserInfo | null;          // 현재 사용자 정보
    setUserInfo: (info: UserInfo) => void;  // 사용자 정보 설정 함수
    clearUserInfo: () => void;          // 사용자 정보 초기화 함수
}

// 사용자 정보 초기 상태
const initialState: UserInfo = {
    userName: '',
    role: ''
};

// Zustand 스토어 생성
// persist 미들웨어를 사용하여 세션 스토리지에 상태 유지
const useUserInfoStore = create(
    persist<UserInfoStore>(
        (set) => ({
            userInfo: initialState,
            setUserInfo: (info) => set({userInfo: info}),         // 사용자 정보 업데이트
            clearUserInfo: () => set({userInfo: initialState})    // 초기 상태로 리셋
        }),
        {
            name: 'user-info-storage',                            // 스토리지 키 이름
            storage: createJSONStorage(() => sessionStorage),      // 세션 스토리지 사용
        }
    )
);

// 사용자 이름을 안전하게 가져오는 selector 함수
// userInfo가 null일 경우 빈 문자열 반환
export const useUserName = () => {
    const userInfo = useUserInfoStore((state) => state.userInfo);
    return userInfo?.userName || '';
};

export default useUserInfoStore;